<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Módulo de declaración de impuestos
    </h2>
    <MainReportDGII />
  </div>
</template>

<script>
import MainReportDGII from "@/components/Reports/Sales/DGII/ReportDGII/MainReportDGII.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ReportDGII",
  components: {
    MainReportDGII,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
